import React from "react";
import { useAuth0 } from "@auth0/auth0-react";

const Logout = () => {
  const { logout } = useAuth0();

  return (
    <button className="auth-btn logout" onClick={() => logout()}>
      Logout
    </button>
  );
};

export default Logout;
